import React from 'react';
import PropTypes from 'prop-types';
import {
     CCard,
     CCardBody,
     CButton,
     CRow,
     CCol,
     CCardHeader,
} from '@coreui/react';

const Step1 = ({ activeStep, setActiveStep, ruleType, setRuleType, actionType }) => {
     const isEditting = (actionType === 'edit');

     const handleSelectRule = (ruleType) => {
          setRuleType(ruleType);
          setActiveStep(2);
     }

     return (
          <>
               {
                    activeStep !== 5 && (
                         <CCard className={`cvr-step-1 ${activeStep !== 1 ? 'difference-step' : 'cvr-step-card'}`}>
                              <CCardHeader>
                                   {
                                        activeStep !== 1 ? (
                                             <div className="rule-step d-inline-flex justify-content-between align-items-center w-100">
                                                  <h5 className="mb-0 inactive">Step 1: Rule Type</h5>
                                                  <div className="d-inline-flex align-items-center">
                                                       <span className="given-data mr-3">{ruleType === "simple" ? "Simple Rule" : "Lookup Rule"}</span>
                                                       {
                                                            !isEditting && (
                                                                 <CButton className="btn-edit" onClick={() => setActiveStep(1)}>
                                                                      Edit
                                                                 </CButton>
                                                            )
                                                       }
                                                  </div>
                                             </div>
                                        ) : (
                                             <h5 className="">Step 1: Select rule type</h5>
                                        )
                                   }
                              </CCardHeader>
                              {
                                   activeStep === 1 ? (
                                        <CCardBody>
                                             <div className="rule-step">
                                                  <CRow className="mb-3">
                                                       <CCol>
                                                            <div className='d-flex align-items-center'>
                                                                 <CButton
                                                                      className=" f-13 mr-5"
                                                                      disabled={isEditting}
                                                                      color={ruleType === "simple" ? "primary" : "dark"}
                                                                      onClick={() => handleSelectRule("simple")}
                                                                      style={{ cursor: isEditting ? 'default' : '' }}
                                                                 >
                                                                      Simple Rule
                                                                 </CButton>
                                                                 <p>Enter one or more conditions to define a single Conversion.</p>
                                                            </div>
                                                       </CCol>
                                                  </CRow>
                                                  <CRow className="mb-3">
                                                       <CCol>
                                                            <div className='d-flex align-items-center'>
                                                                 <CButton
                                                                      className=" f-13 mr-5"
                                                                      disabled={isEditting}
                                                                      color={ruleType === "lookup" ? "primary" : "dark"}
                                                                      onClick={() => handleSelectRule("lookup")}
                                                                      style={{ cursor: isEditting ? 'default' : '' }}
                                                                 >
                                                                      Lookup Rule
                                                                 </CButton>
                                                                 <p>Define multiple triggers using a table that relies on similar conditions.</p>
                                                            </div>
                                                       </CCol>
                                                  </CRow>
                                             </div>
                                        </CCardBody>
                                   ) : ''
                              }
                         </CCard>
                    )
               }
          </>
     )
}


Step1.propTypes = {
     activeStep: PropTypes.any,
     setActiveStep: PropTypes.func,
     setRuleType: PropTypes.func,
     actionType: PropTypes.string,
     ruleType: PropTypes.string,
};

export default Step1
